import { useMutation } from '@apollo/react-hooks';
import * as H from 'history';
import { ToBillArguments, ToBillEvent } from '../../../models/Factura';
import { graphqlSchema } from '../../../services/graphql.schema';
import sharedToasterSubject from '../../../services/shared.toasterSubject';
import { parseStampErrorFromGraphQL } from '../../../utils/error.graphql';

/**
 * Stamping and re-stamping a complemento de pago only differ on their confirmation message.
 */
export function usePagoStamping(history: H.History, onStampError: () => void) {
    const stampingHandlers = (logLabel: string, confirmMessage: string) => ({
        onCompleted: (result: { [key: string]: ToBillArguments<ToBillEvent>[] }) => {
            const stampFromPaymentEvent = Object.values(result)[0];
            console.log(`${logLabel}: `, stampFromPaymentEvent);
            sharedToasterSubject.next({ type: 'confirm', message: confirmMessage });
            history.push({
                pathname: '/',
                state: { stampFromPaymentEvent }
            })
        },
        onError: (e: any) => {
            console.log(`ERROR ON ${logLabel}: `, e.graphQLErrors[0])
            onStampError();
            sharedToasterSubject.next({ message: parseStampErrorFromGraphQL(e.graphQLErrors[0]), clickToClose: true, type: 'error', clearTs: 5200 });
        }
    })

    const [stampPayment] = useMutation(graphqlSchema.FISCALPOP.CFDI.stampFromPaymentEvent,
        stampingHandlers('STAMP FROM PAYMENT', 'Complemento Pago emitido correctamente'));
    const [restampPayment] = useMutation(graphqlSchema.FISCALPOP.CFDI.restampBillPaymentEvent,
        stampingHandlers('RESTAMP FROM PAYMENT', 'Complemento Pago sustituída correctamente'));

    return { stampPayment, restampPayment };
}
